// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* reuse modal backdrop and header styles from CreatePostModal */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.beneficiaries-modal {
  background: var(--card-bg);
  border-radius: 16px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.beneficiaries-modal .modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border-color);
}

.beneficiaries-modal .modal-header h2 {
  margin: 0;
  font-size: 18px;
  color: var(--text-primary);
}

.beneficiaries-modal .close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: var(--text-primary);
}

.beneficiaries-modal .beneficiaries-modal-body {
  padding: 16px 24px;
  flex: 1 1;
}

.beneficiaries-modal .beneficiaries-table {
  width: 100%;
  border-collapse: collapse;
}

.beneficiaries-modal .beneficiaries-table th,
.beneficiaries-modal .beneficiaries-table td {
  padding: 8px;
  border-bottom: 1px solid var(--border-color);
}

.beneficiaries-modal .weight-input {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.beneficiaries-modal .btn-beneficiary-xs {
  padding: 2px 6px;
  font-size: 12px;
}

.beneficiaries-modal .modal-actions {
  padding: 12px 24px;
  border-top: 1px solid var(--border-color);
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.mb-10 { margin-bottom: 10px; }
.mt-10 { margin-top: 10px; }
`, "",{"version":3,"sources":["webpack://./src/components/BeneficiariesModal/BeneficiariesModal.css"],"names":[],"mappings":"AAAA,gEAAgE;AAChE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA,SAAS,mBAAmB,EAAE;AAC9B,SAAS,gBAAgB,EAAE","sourcesContent":["/* reuse modal backdrop and header styles from CreatePostModal */\r\n.modal-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  padding: 20px;\r\n}\r\n\r\n.beneficiaries-modal {\r\n  background: var(--card-bg);\r\n  border-radius: 16px;\r\n  width: 100%;\r\n  max-width: 500px;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.beneficiaries-modal .modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 16px 24px;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.beneficiaries-modal .modal-header h2 {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.beneficiaries-modal .close-btn {\r\n  background: none;\r\n  border: none;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.beneficiaries-modal .beneficiaries-modal-body {\r\n  padding: 16px 24px;\r\n  flex: 1;\r\n}\r\n\r\n.beneficiaries-modal .beneficiaries-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.beneficiaries-modal .beneficiaries-table th,\r\n.beneficiaries-modal .beneficiaries-table td {\r\n  padding: 8px;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.beneficiaries-modal .weight-input {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 4px;\r\n}\r\n\r\n.beneficiaries-modal .btn-beneficiary-xs {\r\n  padding: 2px 6px;\r\n  font-size: 12px;\r\n}\r\n\r\n.beneficiaries-modal .modal-actions {\r\n  padding: 12px 24px;\r\n  border-top: 1px solid var(--border-color);\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n}\r\n\r\n.mb-10 { margin-bottom: 10px; }\r\n.mt-10 { margin-top: 10px; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
